import ActionCard from "@modules/application/components/ActionCard";
import ApplicationLayout from "@modules/application/components/ApplicationLayout";
import { FC } from "react";

interface TransferWithoutPropertyProps {
  onGoToApplication: () => void;
  onGoToBooking: () => void;
  isApplicationLoading: boolean;
  isBookingLoading: boolean;
  isApplicationError: boolean;
  isBookingError: boolean;
  partnerName: string | undefined | null;
}

const TransferWithoutProperty: FC<TransferWithoutPropertyProps> = ({
  onGoToApplication,
  onGoToBooking,
  isApplicationError,
  isApplicationLoading,
  isBookingError,
  isBookingLoading,
  partnerName,
}) => {
  return (
    <ApplicationLayout>
      <div className="grid m:grid-cols-12 gap items-stretch py-3s">
        <div className="mb-m m:mb-xl col-span-12 text-center">
          <h1 className="text-d3 mb-xs">Willkommen bei Justhome</h1>
          <p>
            Finanzierungspartner von{" "}
            <span className="font-medium">{partnerName}</span>
          </p>
        </div>

        <ActionCard
          buttonTestId="funnel-submit"
          isError={isApplicationError}
          isLoading={isApplicationLoading}
          title="Finanzierungsrechner"
          list={[
            "Mehr als 700 Banken und Sparkassen im Vergleich",
            "Finanzierungsszenarien direkt online durchspielen",
            "Unverbindlich und kostenlos",
          ]}
          label="Zum Finanzierungsrechner"
          image={{
            src: "/assets/img/offers-preview.png",
            width: 406,
            height: 320,
            border: true,
          }}
          onClick={onGoToApplication}
          className="col-span-12 m:col-span-6"
        />

        <ActionCard
          buttonTestId="meeting-submit"
          isError={isBookingError}
          isLoading={isBookingLoading}
          title="Kostenfreie Erstberatung"
          list={[
            "Unverbindliches Erstgespräch mit Ihrem Finanzierungsexperten",
            "Für allgemeine Budgetberatung oder konkrete Immobilienfinanzierung",
            "Unverbindlich und kostenlos",
          ]}
          label="Beratung buchen"
          image={{
            src: "/assets/img/lead-wall-slide-4.png",
            width: 246,
            height: 320,
          }}
          onClick={onGoToBooking}
          className="col-span-12 m:col-span-6"
        />
      </div>
    </ApplicationLayout>
  );
};

export default TransferWithoutProperty;
